import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { get_reports_success } from '@rpt-ngrx/actions/reports.action';
import { fetch_companies_success } from '@rpt-ngrx/actions/session.action';
import { disable_content_loader } from '@rpt-ngrx/actions/ui.action';

@Injectable()
export class UiEffects {
    onReportsSet$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(get_reports_success),
            map(() => disable_content_loader()),
        );
    });

    onCompaniesSet$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(fetch_companies_success),
            map(() => disable_content_loader()),
        );
    });

    constructor(private actions$: Actions) {}
}
